"use strict";
/**
 * Highlight menu item based on current page.
 */
document.addEventListener("DOMContentLoaded", function (event) {
    const urlPathYear = parseInt(window.location.pathname.split('/')[1]);
    // console.log({urlPathYear})
    // If a valid year.
    if (urlPathYear >= 2012 && urlPathYear <= 2024) {
        document.getElementById('menu-item-97')?.classList.add('current-menu-item');
        document.querySelector('#rmp-menu-item-97 ul').style.display = 'block';
        document.getElementById('rmp-menu-item-70')?.classList.add('rmp-menu-current-item');
    }
});
